import React, { useEffect } from "react"; // <-- add useEffect here

import { Container, Row, Col, Button } from "react-bootstrap";
import 'aos/dist/aos.css';
import '../styles/NetworkDesign.css'; // Custom styles

const NetworkDesign = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // <-- This forces scroll to top
  }, []);

  return (
    <div className="network-section">
      <Container className="mb-5 py-5" data-aos="fade-up">
        <Row className="align-items-center">
          <Col md={6} data-aos="fade-right">
            <h3 className="fw-bold mb-3">Network Design Services</h3>
            <p className="text-muted mb-4 info-text">
              We provide robust and scalable network design solutions tailored to your business needs. From planning to implementation, we ensure reliable and secure connectivity for your organization.
            </p>
            <ul className="list-unstyled support-list">
              <li>  Customized network infrastructure planning</li>
              <li> Secure LAN/WAN configuration</li>
             
              {/* <li>✔ Secure LAN/WAN configuration</li> */}
              <li> Hardware selection and setup</li>
              <li> Performance optimization and monitoring</li>
              <li> 24/7 network support and maintenance</li>
            </ul>
          </Col>
          <Col md={6} data-aos="fade-left">
            <video
              src="/videos/network_design_new.mp4"
              className="img-fluid rounded shadow network-video mt-5"
              autoPlay
              loop
              muted
              playsInline
            />
          </Col>
        </Row>
                  {/* <div className="divider my-5"></div> */}


        {/* Why Choose Us */}
        <Row className="mt-5 text-center" data-aos="fade-up">
          <h4 className="fw-semibold mb-4">Why Choose Us?</h4>
          <Col md={4}>
            <div className="benefit-card">
              <h6>🚀 Scalable Design</h6>
              <p>Built to grow with your business.</p>
            </div>
          </Col>
          <Col md={4}>
            <div className="benefit-card">
              <h6>🔒 Secure Infrastructure</h6>
              <p>Enterprise-grade data protection.</p>
            </div>
          </Col>
          <Col md={4}>
            <div className="benefit-card">
              <h6>🛠 24/7 Expert Support</h6>
              <p>We're always here to help.</p>
            </div>
          </Col>
        </Row>
                  {/* <div className="divider my-5"></div> */}


        {/* CTA Contact Section */}
        <Row className="justify-content-center mt-5" data-aos="fade-up">
          <Col md={8} className="text-center">
            <h5 className="fw-semibold mb-3">Need expert help with your network?</h5>
            <p className="text-muted mb-4">Contact us now to schedule a consultation and get your network built the right way.</p>
            <Button variant="primary" href="/contact" className="cta-button">
              Contact Us
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NetworkDesign;
